import { API } from "../../../../common/api/constants";

// ПОЛУЧИТЬ СПИСОК ПЕРСОН ПО НОМЕРУ ЗАКАЗА
export const GET_LANDING_LIST = `${API}/order/orders/{order_id}/disembarking_boarding`; // GET

// ПОЛУЧИТЬ СПИСОК ОСТАНОВОК
export const GET_STOPS_LIST = `${API}/request/requests/{order_id}/routes`; // GET

// ОБНОВИТЬ СПИСОК ИЛИ НАЗНАЧИТЬ ПЕРСОН НА ОСТАНОВКУ
export const UPDATE_LANDING_LIST = `${API}/order/orders/{order_id}/disembarking_boarding`; // PUT